export function EvidenceDrawer({
  open,
  title,
  body,
  onClose,
}: {
  open: boolean;
  title: string;
  body: string;
  onClose: () => void;
}) {
  if (!open) return null;

  return (
    <aside
      className="fixed right-0 top-0 z-40 flex h-full w-full max-w-[var(--drawer-width)] flex-col border-l border-[var(--color-border-default)] bg-[var(--color-surface-2)] shadow-xl md:w-[var(--drawer-width)]"
      aria-label="Evidence drawer"
    >
      <header className="flex items-center justify-between border-b border-[var(--color-border-default)] px-4 py-3">
        <h2 className="text-sm font-semibold text-[var(--color-atlas-gold)]">{title}</h2>
        <button
          type="button"
          onClick={onClose}
          className="min-h-[44px] min-w-[44px] rounded-[var(--radius-control)] text-[var(--color-text-muted)] hover:text-[var(--color-text-primary)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[var(--color-signal-cyan)]"
          aria-label="Close evidence drawer"
        >
          ✕
        </button>
      </header>
      <div className="flex-1 overflow-auto p-4 reading-measure text-sm leading-relaxed text-[var(--color-text-secondary)]">
        {body}
      </div>
    </aside>
  );
}
